<template>
  <div>
    <div class="row">
      <div
        class="
          col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12
          pr-0
          d-flex
          align-items-center
        "
      >
        <h1 class="title-pages">ORÇAMENTO</h1>
      </div>
      <div
        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pl-0 text-right pl-0"
      ></div>
    </div>
    <b-overlay :show="loading" opacity="0.99">
      <div class="v-clean p-5 text-center" v-show="data.length == 0">
        <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
      </div>
    </b-overlay>
  </div>
</template>

<script>
export default {
  name: "Budget",
  data() {
    return {
      data: [],
      loading: false,
    };
  },
};
</script>
